import { Tag, type TagProps } from '@chakra-ui/react';

export const StatusTag = ({ variant, children, ...props }: TagProps) => {
  return (
    <Tag variant={variant} border="none" {...props}>
      {children}
    </Tag>
  );
};
